module.exports = __webpack_public_path__ + "static/media/flag-sv.6123fbd0.webp";